import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { TimeRangeFinite } from "types/types";

export enum SliderSideEnum {
  left = "left",
  right = "right",
}

export type RetrotagSliceState = {
  tagPath: string[];
  retrotagSegmentRange: TimeRangeFinite | null;
  retrotagSegmentBoundingRange: TimeRangeFinite | null;
  isRetrotagPopperOpen: boolean;
  retrotagProcessId: string | null;
  sliderSideCurrentlyPressed: SliderSideEnum | null;
};

export const retrotagInitialState: RetrotagSliceState = {
  tagPath: [],
  retrotagSegmentRange: null,
  retrotagSegmentBoundingRange: null,
  isRetrotagPopperOpen: false,
  retrotagProcessId: null,
  sliderSideCurrentlyPressed: null,
};

const retrotagSlice = createSlice({
  name: "retrotag",
  initialState: retrotagInitialState,
  reducers: {
    clearRetrotagState() {
      return retrotagInitialState;
    },
    updateRetrotagTagPath(
      state: RetrotagSliceState,
      action: PayloadAction<string[]>
    ) {
      state.tagPath = action.payload;
    },
    updateRetrotagSegmentRange(
      state: RetrotagSliceState,
      action: PayloadAction<TimeRangeFinite | null>
    ) {
      state.retrotagSegmentRange = action.payload;
    },
    updateRetrotagSegmentBoundingRange(
      state: RetrotagSliceState,
      action: PayloadAction<TimeRangeFinite | null>
    ) {
      state.retrotagSegmentBoundingRange = action.payload;
    },
    updateIsRetrotagPopperOpen(
      state: RetrotagSliceState,
      action: PayloadAction<{ isOpen: boolean; machemetryId?: string | null }>
    ) {
      state.isRetrotagPopperOpen = action.payload.isOpen;
      state.retrotagProcessId = action.payload.machemetryId || null;
    },
    updateSliderSideCurrentlyPressed(
      state: RetrotagSliceState,
      action: PayloadAction<SliderSideEnum | null>
    ) {
      state.sliderSideCurrentlyPressed = action.payload;
    },
  },
});
export const {
  clearRetrotagState,
  updateRetrotagTagPath,
  updateRetrotagSegmentRange,
  updateRetrotagSegmentBoundingRange,
  updateIsRetrotagPopperOpen,
  updateSliderSideCurrentlyPressed,
} = retrotagSlice.actions;
export default retrotagSlice.reducer;
